import { ApiMethodType } from '@celito.clients/enums';
import { performRequest } from '@celito.clients/network';
import { ViewDto } from '@celito.clients/types';
import { raiseErrorToast } from '@celito.clients/utils';
import { AxiosResponse } from 'axios';
import Endpoints from 'libs/core/src/config/endpoint';
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

type TPerformRequestArgsWithoutURL = {
  data: Parameters<typeof performRequest>[2];
  params: Parameters<typeof performRequest>[3];
  config: Parameters<typeof performRequest>[4];
};

export const getObjectDefinition = async <T = unknown>(
  view = '',
  performRequestArgs?: TPerformRequestArgsWithoutURL
) => {
  const args = {
    ...performRequestArgs,
  };
  const response = (await performRequest(
    `${Endpoints.VIEW_METADATA_URL}/${view}`,
    ApiMethodType.GET,
    args.data,
    args.params,
    args.config
  )) as AxiosResponse<T, never>;
  return response;
};

export type TUseObjectDefinitionArgs<T> = {
  view: string;
  queryKey?: QueryKey;
  requestArgs?: TPerformRequestArgsWithoutURL;
  queryOptions?: UseQueryOptions<T>;
};

/**
 * FIXME: Better query Keys and custom query options
 *
 * React hook for fetching object definition from the meta data api
 *
 * Supports passing custom `performRequest` args
 */
export const useView = <T = { viewDto: ViewDto }>({
  view,
  queryKey,
  requestArgs,
  queryOptions,
}: TUseObjectDefinitionArgs<T>) => {
  return useQuery(queryKey ?? [view], {
    queryFn: async () => {
      const { data } = await getObjectDefinition<T>(view, requestArgs);
      return data as T;
    },
    staleTime: 100 * 1000,
    retryDelay: () => 10 * 1000,
    onError: (error) => raiseErrorToast(error),
    ...queryOptions,
  });
};
